export const httpProductsInterceptor = (cb: (http: XMLHttpRequest) => unknown) => {
  const oldXHROpen = XMLHttpRequest.prototype.open;
  // @ts-ignore
  XMLHttpRequest.prototype.open = function(method: string, url: string, async: boolean) {
    if (!url.includes("products")) return;
    this.onload = () => cb(this);
    oldXHROpen.apply(this, [method, url, async]);
  };
};

export function scrollTo(elementY: number, duration = 300): void {
  const startingY = window.pageYOffset;
  const diff = elementY ;
  let start;

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) {
      start = timestamp;
    }
    // Elapsed milliseconds since start of scrolling.
    const time = timestamp - start;
    // Get percent of completion in range [0, 1].
    const percent = Math.min(time / duration, 1);
    window.scrollTo(0, (diff * percent) + startingY);
    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
}

/**
 * taking CSS prop "scrollMarginTop" into account - if not supported, its using the scrollTo method with offset
 */
export const scrollToElement = (element: Element, scrollMarginTop: number = 0, scrollDuration = 300): void => {
  // 100px is just a dummy value to check for support
  const isSupportingScrollMarginTop = (window as any).CSS && (window as any).CSS.supports("scroll-margin-top", "100px");

  if (isSupportingScrollMarginTop) {
    try {
      element.scrollIntoView({behavior: "smooth"});
    } catch {
      element.scrollIntoView(false);
    }
  } else {
    const elementY = element.getBoundingClientRect().top - scrollMarginTop;
    scrollTo(elementY, scrollDuration);
  }
}

export default { httpProductsInterceptor };
